import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import {
  RequestListPage,
  RequestEditPage,
  RequestCreatePage,
  RequestUserListView,
  RequestUserDetailView,
} from './imports';

export const requestRoutes = [
  {
    path: 'requests',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.REQUEST}
            access={OrionAccess.VIEW}
          >
            <RequestListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.REQUEST}
            access={OrionAccess.VIEW}
          >
            <RequestListPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.REQUEST}
            access={OrionAccess.CREATE}
          >
            <RequestCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: 'users',
        children: [
          {
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.REQUEST}
                access={OrionAccess.VIEW}
              >
                <RequestUserListView />
              </PermissionGuard>
            ),
            index: true,
          },
          {
            path: ':id/detail',
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.REQUEST}
                access={OrionAccess.VIEW}
              >
                <RequestUserDetailView />
              </PermissionGuard>
            ),
          },
          {
            path: ':id/edit',
            element: (
              <PermissionGuard
                hasContent
                module={OrionModule.ACCOUNT}
                submodule={OrionSubmodule.ACCOUNT.REQUEST}
                access={OrionAccess.UPDATE}
              >
                <RequestEditPage />
              </PermissionGuard>
            ),
          },
        ],
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.REQUEST}
            access={OrionAccess.UPDATE}
          >
            <RequestEditPage />
          </PermissionGuard>
        ),
      },
    ],
  },
];
